import { Typography, Fab } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import styled from "styled-components";

export const STTypography = styled(Typography)`
  && {
    margin: 20px;
  }
`;

export const STFab = styled(Fab)`
  && {
    transform: scale(0.8);

    background-color: ${red[500]};

    :hover {
      background-color: ${red[700]};
    }
  }
`;
